<template>
  <div>
    <div>
    <b-sidebar id="sidebar-1" title="Zunisport" >
      <div class="px-3 py-2" >
        <ul style=" list-style-type: none;">
          <li v-if="!cookiesObject.token">
            <div>
            <b-btn variant="success" style="margin-left: -20px;" v-b-modal.modal-multi-1>{{ $t('LanguageEn.loginButton') }}</b-btn>
            <b-modal id="modal-multi-1" size="lg" title="First Modal" hide-header hide-footer no-stacking>
            <p>Enter your number</p><br>
            <VuePhoneNumberInput v-model="number" @update="onUpdate" maxlength="13" style="margin-bottom: 8px;" :default-country-code="forNumInput"/>
            <b-button variant="success" v-on:click="numberCookie(), regSign()" style="width: 100%;">{{ $t('LanguageEn.txtNext') }}</b-button>
          </b-modal>
          <b-modal ref="regText-modal2" style="" hide-footer hide-header title="" >
        <h1 v-if="introText.code == 200">{{introText.page.title}}</h1>
        <p v-if="introText.code == 200">{{introText.page.text}}</p>
        <b-row>
        <b-col>
            <button type="submit" class="btn mbtn btn-default btn-block"  style="z-index: 0; background: none; color: #ff324d;" @click="$refs['regText-modal2'].hide()">Cancel</button>
        </b-col>
        <b-col>
            <button type="submit" class="btn btn-default btn-block" style="z-index: 0; background: none; color: #228c39;" @click="$refs['regText-modal2'].hide(), $refs['otp-modal2'].show()">Register</button>
        </b-col>
        </b-row>
    </b-modal>
          <b-modal ref="otp-modal2" id="modal-multi-2" title="Second Modal" hide-header hide-footer >
        <input type="phone" class="form-control col" maxlength="5" id="exampleFormControlInput1" placeholder="Received Code" v-model="OTP"><br>
            <b-button v-b-modal.modal-multi-3 size="sm" variant="success" v-on:click="verify()">{{ $t('LanguageEn.txtSubmit') }}</b-button>
          </b-modal>
        </div>
          </li>
          <li v-if="cookiesObject.token">
            <p class="goldenP goldLogin" style="font-weight: 600; margin-left: -20px;">{{cookiesObject.number}}
            <b-btn v-on:click="logout()" class="bg-transparent" style="color: white; border: none; margin-left: 10px;"><img style="width: 35px;" src="@/assets/logout_button.png"></b-btn>        
            </p> 
          </li>
        </ul>
        <div style="margin-left: 20px;">
          <h5 style="color: green; font-weight: 600;" >{{ $t('LanguageEn.txtSetting') }} </h5>
          <div>
          <b-button v-b-modal.modal-1 variant="none" style="border: none;"> <img style="height: 18px; margin-right: 5px;" src="@/assets/globe.png">{{ $t('LanguageEn.txtLanguage') }}</b-button>
          <b-modal id="modal-1" :title="$t('LanguageEn.txtLanguage')" hide-footer >
            <p class="my-4" v-for="language in languages" :key="language.id" @click="changeLang(language.code, language.id)" style="cursor: pointer;"> <span v-bind:class="{selectedLang: cookiesObject.lang == language.code}">{{language.name}}</span></p>
          </b-modal>
        </div>
        <div>
          <b-button v-b-modal.modal-about variant="none" style="border: none;"> <img style="height: 18px; margin-right: 5px;" src="@/assets/globe.png">{{ $t('LanguageEn.txtAbout') }}</b-button>
          <b-modal id="modal-about" :title="$t('LanguageEn.txtAbout')" hide-footer style="text-align: center !important;" >
            <p class="my-4">
              {{about}}
            </p>
          </b-modal>
        </div>
        <div>
          <b-button v-b-modal.modal-terms variant="none" style="border: none;"> <img style="height: 18px; margin-right: 5px;" src="@/assets/globe.png">{{ $t('LanguageEn.txtTermsAndConditions') }}</b-button>
          <b-modal id="modal-terms" :title="$t('LanguageEn.txtTermsAndConditions')" hide-footer >
            <p class="my-4">
              {{terms}}
            </p>
          </b-modal>
        </div>

        </div>
         
        <div>
  </div>
      </div>
    </b-sidebar>
  </div>
    <h3 class="topNav sticky-top container-fluid">
      <div class="row">
      <b-button  v-b-toggle.sidebar-1 type="button" class="btn MenuButton col-1" style="margin-top: 5px; font-weight: 600;"><img src="@/assets/mobile/menuIcon.png" style="width: 25px; height: 25px;"></b-button> 
      <router-link class="col-4" id="routerLink" to="/Today"><img src="@/assets/zuniLogo.svg" width="100px" height="20px" style="margin-top: 20px;"/></router-link>
      <div class="col" style="margin-left: auto; background: none; border: none; padding-left: 2px; color: white !important;" v-on:click="dateIden = value ,setLIDs(), redirect()">
             <b-form-datepicker button-only selected-variant="success" button-variant="success" today-variant="success"  placeholder="Today" id="example-datepicker" right size="md" v-model="value" class="mb-2" style="border: none;  background: none; margin-top: 7px;  border-radius: 0px; float: right;"></b-form-datepicker>
      </div>
       <span class="" style="margin-right: 10px; margin-top: 3px;">
              <b-button v-b-modal.modal-search2 style="background: none; border: none;"><img src="@/assets/search.png" style="width: 16px;" alt=""></b-button>
                <b-modal ref='mysearch-modal' id="modal-search2" title="search" hide-header hide-footer>
                  <div class="row" style="margin-bottom: 15px; margin-left: 1px; margin-right: 1px;">
                  <b-form-input class="col" v-model="message" placeholder="Search"></b-form-input>
                  <b-button variant="none" @click="searchT(message)" style="margin-left: 2px;" class="col-2">
                    <img src="@/assets/searchBlack.png" style="width: 28px; margin-top: -3px;" alt="">
                  </b-button>
                  </div>
                  <b-tabs v-if="appear" content-class="mt-2" justified style="background: white;"  active-nav-item-class="text-white bg-success" >
                <b-tab active>
                <template v-slot:title>
                    <p style="margin: 0px; color: #333333; font-size: 12px;">teams</p>
                </template>
               <ul v-for="searchr in search" :key="searchr.id" style="list-style-type: none;">
                  <li v-if="searchr.type == 'team'">
                    <div v-if="cookiesObject.token" @click="hideModal()">
                    <router-link class="kek" style="color:black;" id="router-link" :to="{ name: 'teamPagePar', params: { id: searchr.id} }"> 
                      {{searchr.name}}
                    </router-link>
                    </div>
                    <span class="kek" v-else v-b-modal.modal-multi-1 @click="hideModal()" style="cursor: pointer;"> {{searchr.name}} </span>
                  </li>
               </ul>
                </b-tab>
                <b-tab >
                <template v-slot:title >
                    <p style="margin: 0px; color: #333333; font-size: 12px;">tournaments</p>
                </template>
                  <ul v-for="searchr in search" :key="searchr.id" style="list-style-type: none;">
                  <li v-if="searchr.type == 'tournament'">
                    <div v-if="cookiesObject.token"  @click="hideModal()">
                     <router-link class="kek" style="color:black;" id="router-link" :to="{ name: 'LeaguePageNav', params: { leagueId: searchr.id} }"> 
                      {{searchr.name}}
                    </router-link>
                    </div>
                    <span class="kek" v-else  @click="hideModal()" v-b-modal.modal-multi-1 style="cursor: pointer;"> {{searchr.name}} </span>
                    </li>
               </ul>
                </b-tab>
                  </b-tabs>
                </b-modal>
            </span>
      </div>
      </h3>
      <router-view/>
      <div class="middleSection"></div>
     <nav class="nav footer fixed-bottom">
       <div class="row container">
       <div class="col pl-0">
       <router-link id="routerLink" :to="{ name: 'Today', params: { value: value } }"><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/allGames.png"><br>{{ $t('LanguageEn.tabToday') }}</router-link>
       </div>
       <div  v-if="cookiesObject.token" class="col ">
       <router-link id="routerLink" :to="{ name: 'PredictionsList', params: { } }"><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/predict.png"><br>Guess</router-link>
       </div>
       <div v-else class="col ">
       <div id="routerLink" v-b-modal.modal-multi-1><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/predict.png"><br>Guess</div>
       </div>
        <div class="col ">
       <router-link id="routerLink" :to="{ name: 'Live', params: { value: value } }"><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/live.png"><br>{{ $t('LanguageEn.tabLive') }}</router-link>
       </div>
       <div class="col " v-if="cookiesObject.token">
       <router-link id="routerLink" :to="{ name: 'MyGames', params: { value: value } }"><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/Favorite.png"><br>{{ $t('LanguageEn.txtFavorite') }}</router-link>
       </div>
       <div class="col " v-else>
       <div id="routerLink" v-b-modal.modal-multi-1 ><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/Favorite.png"><br>{{ $t('LanguageEn.txtFavorite') }}</div>
       </div>
       <div class="col">
       <router-link id="routerLink" to="/Leagues"><img style="height: 20px; margin-top: 5px;" src="@/assets/mobile/leagues.png"><br>{{ $t('LanguageEn.txtLeagues') }}</router-link>
       </div>
       </div>
    </nav>

    <b-modal ref="error-modal" size="sm" hide-footer hide-header>
        <p style="text-align: center;">{{errorText}}</p>
        <b-row>
        <b-col style="text-align: left;">
        </b-col>
        <b-col style="text-align: right;">
            <b-button  type="submit" class="" @click="$refs['error-modal'].hide()" variant="outline-success">CLOSE</b-button>
        </b-col>
        </b-row>
    </b-modal>
  </div> 
</template>

<script>
import { mapActions } from "vuex";
import {mapGetters} from 'vuex';
import VuePhoneNumberInput from 'vue-phone-number-input';

export default {

  name: 'MobileNav',
     data(){
      return{
          value: '',
          dateIden: '',
          OTP: '',
          number: '',
          portalLenght: '',
          regOrNot: '',
          token: '',
          clientToken: Date.now() + '_' + this.number,
          username: '',
          cookiesObject: '',
          UserName: '',
          results: {},
          selected: '',
          languages: [],
          terms: '',
          about: '',
          search: '',
          message: '',
          appear: false,
          introText: '',
          forNumInput: '',
          errorText:'',
      }
  },
  async mounted(){
    var res = await fetch(this.httpReq + '/general/appData');
    var data = await res.json();
    var portalLenght = data.portals.length;
    this.portalLenght = portalLenght;

    if (data.portals[0].countryCode == "--") {
      this.forNumInput = "US";
    } else {
      this.forNumInput = data.portals[0].countryCode;
    }

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    if (cookiesObject.token) {
    const res3 = await fetch(this.httpReq + '/general/appData?token=' + this.cookiesObject.token, {method: 'get'});
    const data3 = await res3.json();
    const languages = data3.portal.languages;
    this.languages = languages;
    } else {
    const res3 = await fetch(this.httpReq + '/general/appData?portalId=' + this.cookiesObject.portalId, {method: 'get'});
    const data3 = await res3.json();
    const languages = data3.portal.languages;
    this.languages = languages;
    }
    var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

    var requestOptions = {
          method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(this.httpReq +"/general/page?languageId="+this.cookiesObject.langId+"&link=terms&portalId="+ this.cookiesObject.portalId, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.text) {
        this.terms = result.text
        } else{
        this.terms = 'No information at the moment';
        }
        
        })
      .catch(error => console.log('error', error));  
    
  var myHeaders2 = new Headers();
  myHeaders2.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

    var requestOptions2 = {
      method: 'GET',
      headers: myHeaders2,
      redirect: 'follow'
    };

    fetch(this.httpReq +"/general/page?languageId="+this.cookiesObject.langId+"&link=about&portalId="+ this.cookiesObject.portalId, requestOptions2)
      .then(response => response.json())
      .then(result => {
        if (result.text) {
        this.about = result.text
        } else{
        this.about = 'No information at the moment';
        }
        
        })
      .catch(error => console.log('error', error));  

    if (!this.cookiesObject.token) {
    this.$i18n.locale = this.cookiesObject.lang;
    }

    var respons = await fetch(this.httpReq + '/general/page?languageId='+ this.cookiesObject.langId +'&link=registration_intro&portalId=' + this.cookiesObject.portalId);
    var datafrom = await respons.json();
    this.introText = datafrom; 
    
    // if (this.cookiesObject.lang != '') {
    // this.$i18n.locale = this.cookiesObject.lang;
    // }

    this.$forceUpdate();
  },

computed: {
   ...mapGetters(['dateNtime', 'lang','httpReq']),
   resultsTable () {
        return Object.keys(this.results)
      },
  },  
  methods: {
    ...mapActions(['setdateNtime', 'setLang']),
    hideModal() {
        this.$refs['mysearch-modal'].hide()
      },
    logout(){
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "lang = en; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    },
    setLIDs(){
            this.setdateNtime(this.dateIden);
        },
         redirect(){
          if (this.value != undefined) {
           this.$router.push({ name: 'Finished', params: { dateS: this.value } })         
          }
        },
        
        numberCookie(){
       document.cookie = 'number =' + this.number + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    },
    changeLang(value, value1){
      this.setLang(value, value1);
      if (this.lang != undefined) {
      this.$i18n.locale = this.cookiesObject.lang;
       document.cookie = 'lang =' + value;
       document.cookie = 'langId =' + value1;

      if (this.cookiesObject.token) {
              var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234");

    var requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(this.httpReq +"/user/language?languageId="+ value1 +"&token=" + this.cookiesObject.token, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error))
      .then( setTimeout(function some() {
              location.reload();
      }, 500));
      }  
      else{
        location.reload();
      }    
      }
    },

    async regSign(){
    var res = await fetch(this.httpReq + '/user/status?msisdn=' + this.results.formattedNumber.slice(1));
    var data = await res.json();
    var regOrNot = data.code;

    this.regOrNot = regOrNot;

    if (regOrNot == 200) {
    var res1 = await fetch(this.httpReq + '/user/login/otp?msisdn=' + this.results.formattedNumber.slice(1) , { method: 'post'});
    await res1.json();

    this.$refs['otp-modal2'].show()

    } else if (regOrNot == 404) {

      if (data.portals.length == 0) {
        alert('Number is not allowed for this service')
      } else {

      var res2 = await fetch(this.httpReq + '/user/register/otp?msisdn=' + this.results.formattedNumber.slice(1) + '&portalId=' + data.portals[0].id , { method: 'post'});
      var dataresp = await res2.json();

       if (this.cookiesObject.regText == 1) {
      this.$refs['regText-modal2'].show()
        } else {
      this.$refs['otp-modal2'].show()
        }  

      if (dataresp.code == 200) {
      // ok cool
    }
    else if (dataresp.code == 405) {
      alert('Already registered')
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(dataresp.code == 404){
        alert('Portal not matched, not found')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(dataresp.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(dataresp.code == 818){
        alert('Subscription system error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    } 
    }

    this.regOrNot = regOrNot;
    
    },
    

    async verify(){

    if (this.regOrNot == 404) {
    var res3 = await fetch(this.httpReq + '/user/register/verify?clientToken='+ this.clientToken +'&msisdn='+ this.results.formattedNumber.slice(1) +'&otp=' + this.OTP , {method: 'post'});
    var data3 = await res3.json();
    var token = data3.token;
    this.token = token;

  if (data3.code == 406) {
        this.errorText = 'You entered Wrong OTP';
        this.$refs['error-modal'].show();
    }else if(data3.code == 500){
        this.errorText = 'Service error, try logging later';
        this.$refs['error-modal'].show();
    } else if (data3.code == 200){

   document.cookie = 'token =' + this.token + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';

    var res13 = await fetch(this.httpReq + '/general/appData?token=' + this.token);
    var data13 =  await res13.json();
    document.cookie = 'portalId =' + data13.portal.id + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    document.cookie = 'countryCode =' + data13.portal.countryCode;

    this.reLoad();
    }
    else {
      alert('Service Side error, Try re-logging soon');
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      location.assign("/");
    }
      
    } else if (this.regOrNot == 200){
    var res = await fetch(this.httpReq + '/user/login/verify?clientToken='+ this.clientToken +'&msisdn='+ this.results.formattedNumber.slice(1) +'&otp=' + this.OTP , {method: 'post'});
    var data = await res.json();
    var token1 = data.token;
    this.token = token1;

    if (data.code == 406) {
        this.errorText = 'You entered Wrong OTP';
        this.$refs['error-modal'].show();
    }else if(data.code == 500){
        this.errorText = 'Service error, try logging later';
        this.$refs['error-modal'].show();
    }
    
    else if(data.code == 200){

   document.cookie = 'token =' + this.token + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';

  
    var res12 = await fetch(this.httpReq + '/general/appData?token=' + this.token);
    var data12 =  await res12.json();
    document.cookie = 'portalId =' + data12.portal.id + ';expires = Thu, 01 Jan 2040 00:00:00 GMT;';
    document.cookie = 'countryCode =' + data12.portal.countryCode;

    this.reLoad();
    }
    }
    else {
      alert('Service Side error, Try re-logging soon');
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      location.assign("/");
    }
    },
     onUpdate (payload) {
        this.results = payload
      },

     reLoad(){
      setTimeout(function some() {
              location.assign("/");
      }, 100);
    }, 
    async searchT(value){
        const res = await fetch(this.httpReq + '/search?portalId=' + this.cookiesObject.portalId +'&query=' + value);
        const data = await res.json();
        const search = data.results;
        this.search = search;
        this.appear = true;
        },  
      
  },
  components: {
   VuePhoneNumberInput,
  },
  props: {
  }
}
</script>

<style scoped>
.selectedLang{
 color: green;
 font-weight: bold;
}
.topNav{
    height: 50px;
    color: white !important;
    background: #28a745 !important;
    width: 100%;
}
.MenuButton{
    color: white;
}
.nav{
    justify-content: center;
    width: 100%;
    background: #1b1d20;
    height: 50px;
    justify-content: center;
}

#routerLink{
      display: inline-block;
      text-decoration: none; 
      color: white;
      width: 60px;
      font-size: 12px;
      text-align: center;
      color: #7cb342;
      font-weight: 610;
      letter-spacing: 0.2px;
}
 #router-link, #router-link:visited, #router-link:active, #router-link:focus{
    text-decoration: none;
    border: 0;
    outline: 0;
    color: #242424;
  }

.middleSection{
  height: 50px;
}

.MenuButton{
  background: none;
  height: 50px;
  border: none;
}

</style>
